import styled from 'styled-components';

export const Content = styled.div`
  text-align: left;

  .input-wrapper {
    display: flex;
    flex-direction: column;
    gap: 10px;

    .label {
      font-size: 12px;
      font-style: normal;
      font-weight: 500;
      line-height: 100%;
      color: var(--color-text-muted);
      padding: 0 10px 0 0;
    }

    .input,
    .switch,
    .select,
    .textarea {
      margin: 0 0 20px;
    }

    .name {
      color: var(--color-text);
      font-size: 16px;
      font-style: normal;
      font-weight: 400;
      line-height: 150%;
      padding: 0 0 20px;
    }

    input {
      height: 40px;
    }
  }

  .card,
  .rate {
    color: var(--color-text);
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 150%;
    padding: 0 0 20px;

    &.red {
      color: red;
    }
  }

  .description {
    color: var(--color-text-subtle);
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 130%;
    padding: 0 0 10px;

    p {
      padding: 0 0 2px 8px;
      margin: 0;

      &:first-child {
        padding-left: 0;
      }
    }
  }

  .buttonGroup {
    display: flex;
    gap: 10px;
    justify-content: flex-end;
    margin-top: 20px;

    button {
      width: 130px;
    }
  }
`;
